module.exports = __webpack_public_path__ + "img/Home SvIT Home_Logo-05-2.880f0d0d.svg";